// HeadersAlternative.jsx
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { Container, Row, Col } from "reactstrap";
import logo2 from "../../assets/eksiogluPictures/logo-white.png";

const HeadersAlternative = () => {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState("");
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const sliderRef = useRef(null);
  const [autoplayOn, setAutoplayOn] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    axios
      .get("https://eksiogluhukukofisi.pythonanywhere.com/postApi/posts/")
      .then((response) => {
        const updatedPosts = response.data.slice(-10);
        setPosts(updatedPosts);
      })
      .catch((err) => {
        setError(err.message || "Veri çekilirken hata oluştu.");
        console.error(err);
      });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (sliderRef.current && sliderRef.current.slickNext) {
        sliderRef.current.slickNext();
      }
      setAutoplayOn(true);
      if (sliderRef.current && sliderRef.current.slickPlay) {
        sliderRef.current.slickPlay();
      }
    }, 60000);

    return () => clearTimeout(timer);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: autoplayOn,
    speed: 1000,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    className: "overflowStyle",
    arrows: true,
  };

  return (
    <div className="slider-container" style={{ position: "relative" }}>
      <style>{`
        .slider-container .slick-slider { visibility: hidden; }
        .slider-container .slick-slider.slick-initialized { visibility: visible; }
        /* Kayma/sekme olmasın: yükseklik davranışı tutarlı */
        .slider-container .slick-list, 
        .slider-container .slick-track { height: 100vh; }
        .slider-container .slick-slide { outline: none; }
      `}</style>

      <Slider ref={sliderRef} {...settings}>
        <div
          className="page-header header-filter"
          style={{ position: "relative", minHeight: "100vh" }}
        >
          {/* Arka plan (gradient) */}
          <div
            className="page-header-image font-sans"
            style={{
              // background: "linear-gradient(135deg, #164E63, #B45309)",
              background: "linear-gradient(135deg, #17223bff, #364358ff)",
              // background: "linear-gradient(135deg, #1E293B, #CA9457)",
              // background: "linear-gradient(135deg, #0F172A, #333333)",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundSize: "cover",
              backgroundPosition: "center center",
              zIndex: -2,
            }}
          />

          <Container
            className="text-left font-sans"
            style={{ position: "relative", zIndex: 2 }}
          >
            <Row className="align-items-center" style={{ minHeight: "100vh" }}>
              <Col
                md="8"
                className="flex flex-col w-full h-full md:items-start items-center md:justify-start justify-center"
              >
                <img src={logo2} className="w-[210px] mb-2" alt="logo" />
                <h1
                  style={{
                    fontSize: isMobile ? "2em" : "3em",
                    lineHeight: 1.2,
                    marginTop: 0,
                    color: "#ffffff",
                    textAlign: isMobile ? "center" : "left",
                  }}
                  className="mb-4 font-bold"
                >
                  EKŞİOĞLU HUKUK
                </h1>
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    maxWidth: 640,
                    color: "#e5e7eb",
                    marginTop: "0.5rem",
                    textAlign: isMobile ? "center" : "left",
                  }}
                >
                  Ekşioğlu Hukuk ve Danışmanlık, Türkiye’nin 81 ilinde doğrudan
                  faaliyet gösteren, yenilikçi çözümleri ve alanında uzman
                  kadrosu ile müvekkillerine en üst düzey hizmeti sunmaktadır.
                </p>
                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                  <a
                    href="/hakkimizda"
                    style={{
                      display: "inline-block",
                      marginTop: "1.5rem",
                      padding: "0.75rem 1.5rem",
                      backgroundColor: "#ffffff",
                      color: "#0F172A",
                      borderRadius: "0.375rem",
                      fontWeight: "bold",
                      textDecoration: "none",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#ddd";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                    }}
                    className="font-sans"
                  >
                    Hizmetlerimizi Keşfedin
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* API'DEN GELEN SLAYTLAR */}
        {posts.map((post, index) => (
          <div
            className="page-header header-filter"
            key={index}
            style={{ position: "relative", minHeight: "100vh" }}
          >
            {/* Arka plan görseli */}
            <div
              className="page-header-image"
              style={{
                backgroundImage: `url(${post.title_image})`,
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                zIndex: -2,
              }}
            />
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(15, 23, 42, 0.7)",
                zIndex: -1,
              }}
            />

            {/* İçerik */}
            <Container
              className="text-left"
              style={{ position: "relative", zIndex: 2 }}
            >
              <Row
                className="align-items-center"
                style={{ minHeight: "100vh" }}
              >
                <Col md="8">
                  <h1
                    style={{
                      fontSize: isMobile ? "2em" : "3em",
                      lineHeight: 1.2,
                      marginTop: isMobile ? "-5rem" : undefined,
                      color: "#ffffff",
                    }}
                    className="font-sans"
                  >
                    {post.title}
                  </h1>

                  <a
                    href={`/blog/${post.slug}`}
                    style={{
                      display: "inline-block",
                      marginTop: "1.5rem",
                      padding: "0.75rem 1.5rem",
                      backgroundColor: "#ffffff",
                      color: "#0F172A",
                      borderRadius: "0.375rem",
                      fontWeight: "bold",
                      textDecoration: "none",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#ddd";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                    }}
                    className="font-sans"
                  >
                    Detayları İncele
                  </a>
                </Col>
              </Row>
            </Container>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeadersAlternative;
